var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9537 38.375L21.2812 33.5V69.5225C21.2816 69.9138 21.359 70.3013 21.509 70.6627C21.6591 71.0241 21.8789 71.3525 22.1558 71.6289C22.4328 71.9054 22.7615 72.1247 23.1232 72.2741C23.4848 72.4236 23.8724 72.5003 24.2637 72.5H72.0137C72.4055 72.501 72.7936 72.4247 73.1559 72.2756C73.5181 72.1264 73.8474 71.9073 74.1249 71.6307C74.4024 71.3542 74.6226 71.0256 74.773 70.6639C74.9234 70.3021 75.0009 69.9143 75.0012 69.5225V56.25L48.9537 38.375Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9537 7.5H24.2637C23.8724 7.49967 23.4848 7.57643 23.1232 7.72588C22.7615 7.87534 22.4328 8.09457 22.1558 8.37106C21.8789 8.64754 21.6591 8.97587 21.509 9.33729C21.359 9.69872 21.2816 10.0862 21.2812 10.4775V23.75L48.9537 40L63.6063 44.875L75.0012 40V23.75L48.9537 7.5Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2812 23.75H48.9537V40H21.2812V23.75Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.0863 20.5H21.2812V61.125H41.0863C41.8754 61.1211 42.6313 60.8064 43.19 60.249C43.7487 59.6917 44.0653 58.9367 44.0713 58.1475V23.4775C44.0653 22.6883 43.7487 21.9333 43.19 21.376C42.6313 20.8186 41.8754 20.5039 41.0863 20.5Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.4587 22.125H21.2812V62.75H39.4587C40.2479 62.7461 41.0038 62.4314 41.5625 61.874C42.1212 61.3167 42.4378 60.5617 42.4437 59.7725V25.1025C42.4378 24.3133 42.1212 23.5583 41.5625 23.001C41.0038 22.4436 40.2479 22.1289 39.4587 22.125Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.4587 22.125H21.2812V59.5H39.4587C40.2479 59.4961 41.0038 59.1814 41.5625 58.624C42.1212 58.0667 42.4378 57.3116 42.4437 56.5225V25.1025C42.4378 24.3133 42.1212 23.5583 41.5625 23.001C41.0038 22.4436 40.2479 22.1289 39.4587 22.125Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.8312 22.125H21.2812V59.5H37.8312C38.6204 59.4961 39.3763 59.1814 39.935 58.624C40.4937 58.0667 40.8103 57.3116 40.8162 56.5225V25.1025C40.8103 24.3133 40.4937 23.5583 39.935 23.001C39.3763 22.4436 38.6204 22.1289 37.8312 22.125Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.985 22.125H37.83C38.6206 22.1243 39.3791 22.4376 39.9388 22.9959C40.4985 23.5542 40.8137 24.3119 40.815 25.1025V54.8975C40.8137 55.6881 40.4985 56.4458 39.9388 57.0041C39.3791 57.5624 38.6206 57.8757 37.83 57.875H7.985C7.59345 57.8757 7.20561 57.7991 6.84365 57.6498C6.48168 57.5005 6.15269 57.2814 5.87547 57.0048C5.59826 56.7283 5.37825 56.3999 5.22803 56.0383C5.07782 55.6767 5.00033 55.2891 5 54.8975V25.1025C5.00033 24.711 5.07782 24.3233 5.22803 23.9617C5.37825 23.6001 5.59826 23.2717 5.87547 22.9952C6.15269 22.7187 6.48168 22.4995 6.84365 22.3502C7.20561 22.2009 7.59345 22.1243 7.985 22.125Z",
    fill: "url(#paint0_linear_5388_40178)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 49.6814L20.5275 39.9714L14.7775 30.3164H19.395L22.5325 36.4989C22.8225 37.0839 23.0325 37.5189 23.1275 37.8089H23.17C23.375 37.3389 23.5925 36.8864 23.82 36.4439L27.175 30.3264H31.425L25.5275 39.9264L31.575 49.6889H27.0525L23.4275 42.9114C23.2592 42.62 23.1162 42.3147 23 41.9989H22.94C22.8343 42.3066 22.6934 42.6011 22.52 42.8764L18.7875 49.6814H14.25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0156 7.5H48.9531V23.75H75.0006V10.4775C75.0003 10.086 74.9228 9.69831 74.7726 9.33672C74.6224 8.97513 74.4024 8.64669 74.1252 8.37017C73.8479 8.09365 73.5189 7.87448 73.157 7.72517C72.795 7.57586 72.4072 7.49935 72.0156 7.5Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9531 40H75.0006V56.25H48.9531V40Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5388_40178",
    x1: 11.235,
    y1: 19.785,
    x2: 34.58,
    y2: 60.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.1c3ff2ec85bfd881fee94226f7e40ffd.svg";
export { ForwardRef as ReactComponent };